<div class="modal fade" role="dialog" id="dannoBiologicoModal">
  <div class="modal-dialog" [attr.role]="'document'">
      <div class="modal-content">
          <p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
              <button (click)="close()" class="btn btn-default-reverse btn-block btn-sm" [attr.data-dismiss]="'modal'"
                  type="button">Chiudi</button>
          </p>
          <div class="titleblock">
            <h3 class="title1levelNoMargin" style="margin-top: 0;">Danno biologico</h3>
          </div>
          <app-personalizzazione-danno-biologico-form (onReturn)="onReturn($event)"#dannoBiologicoFormComponent></app-personalizzazione-danno-biologico-form>
      </div>
  </div>
</div>
